export const sharedTooltipProps = {
  disableInteractive: true,
  slotProps: {
    popper: {
      sx: { zIndex: 2300 },
      modifiers: [{ name: 'offset', options: { offset: [0, -10] } }],
    },
  },
};
